import { Filters, NoteThread } from "toptaal-shared"
import { Location } from "../types/locations"

export const locationQueryKeys = {
  all: ["locations"] as const,
  detail: (id: Location["id"]) => [...locationQueryKeys.all, id] as const,
  documents: (id: Location["id"]) =>
    [...locationQueryKeys.detail(id), "documents"] as const,
  notes: (id: Location["id"]) =>
    [...locationQueryKeys.detail(id), "notes"] as const,
  noteThread: (id: Location["id"], threadId: NoteThread["id"]) =>
    [...locationQueryKeys.notes(id), "thread", threadId] as const,
  filters: (filters: Filters) =>
    [...locationQueryKeys.all, "filters", filters] as const,
  infinite: (filters: Omit<Filters, "page">) =>
    [...locationQueryKeys.all, "filters", filters] as const,
}
